import { createSupportingModule, DEFAULT_PRODUCT_VALUE, DEFAULT_SORT, SECTION_TYPES } from './shared/configs';

enum SECTION_ENUM {
  PERSONAL_TECHNOLOGY = 'パーソナルテクノロジー',
  JOURNAL_REPORTS = 'Journal Reports',
  KEYWORDS = 'Keywords'
}
const { TECH, PERSONAL_TECHNOLOGY, KEYWORDS, JOURNAL_REPORTS } = SECTION_TYPES;

const baseQuery = {
  query: {
    and: [
      { terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      { terms: { key: 'SectionType', value: [TECH, PERSONAL_TECHNOLOGY, KEYWORDS] } }
    ]
  },
  ...DEFAULT_SORT
};

const PERSONAL_TECHNOLOGY_QUERY = createSupportingModule([PERSONAL_TECHNOLOGY]);
const JOURNAL_REPORTS_QUERY = createSupportingModule([JOURNAL_REPORTS]);
const KEYWORDS_QUERY = createSupportingModule([KEYWORDS]);

export { SECTION_ENUM, baseQuery as MAIN, PERSONAL_TECHNOLOGY_QUERY, JOURNAL_REPORTS_QUERY, KEYWORDS_QUERY };
